module.exports = __webpack_public_path__ + "fonts/MADETheArtistSans.d25a4c5c.woff2";